import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import AssignmentIndRoundedIcon from '@mui/icons-material/AssignmentIndRounded';

export const APPROVAL_DETAILS_DECISION_STEPS = [
  { label: 'Awaiting review', Icon: AssignmentIndRoundedIcon },
  { label: 'Requested additional information', Icon: InfoOutlinedIcon },
  { label: 'Approved', Icon: ThumbUpAltRoundedIcon },
];
